// InvoicePDF.jsx
import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";

// Paste your styles object here (you provided it already).
// I assume it's in scope as `styles`. If stored elsewhere, import or include it.
const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    fontSize: 10,
    padding: 30,
    backgroundColor: "#ffffff",
    color: "#2c2c2c",
    paddingBottom: 75,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 20,
    paddingBottom: 15,
    borderBottomWidth: 3,
    borderBottomColor: "#2c3e50",
    borderBottomStyle: "solid",
  },
  headerLeft: {
    flex: 1,
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },
  logoContainer: {
    width: 60,
    height: 60,
    borderRadius: 4,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#e0e0e0",
    borderStyle: "solid",
  },
  logo: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  hotelInfo: {
    flex: 1,
  },
  hotelName: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 4,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  hotelContact: {
    fontSize: 8,
    color: "#555",
    lineHeight: 1.5,
    marginBottom: 1,
  },
  headerRight: {
    width: 180,
    alignItems: "flex-end",
  },
  invoiceTitle: {
    fontSize: 22,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
    letterSpacing: 1,
  },
  invoiceBox: {
    backgroundColor: "#2c3e50",
    padding: 8,
    borderRadius: 3,
    width: "100%",
  },
  invoiceLabel: {
    fontSize: 7,
    color: "#bdc3c7",
    marginBottom: 2,
    textTransform: "uppercase",
  },
  invoiceValue: {
    fontSize: 10,
    color: "#fff",
    fontWeight: "bold",
  },
  infoGrid: {
    marginBottom: 20,
  },
  infoRow: {
    flexDirection: "row",
    gap: 15,
  },
  infoBox: {
    flex: 1,
    backgroundColor: "#f8f9fa",
    padding: 12,
    borderLeftWidth: 3,
    borderLeftColor: "#3498db",
    borderLeftStyle: "solid",
    marginBottom: 12,
  },
  infoTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#2c3e50",
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  infoDetailRow: {
    flexDirection: "row",
    marginBottom: 4,
  },
  infoLabel: {
    fontSize: 8,
    color: "#7f8c8d",
    width: "35%",
  },
  infoValue: {
    fontSize: 8,
    color: "#2c3e50",
    width: "65%",
    fontWeight: "bold",
  },
  table: {
    marginTop: 15,
    marginBottom: 20,
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#34495e",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  tableHeaderText: {
    color: "#ecf0f1",
    fontSize: 9,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  colDate: { width: "12%" },
  colDesc: { width: "53%" },
  colRoom: { width: "15%" },
  colAmount: { width: "20%", textAlign: "right" },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#ecf0f1",
    borderBottomStyle: "solid",
  },
  tableRowAlt: {
    backgroundColor: "#f8f9fa",
  },
  tableCell: {
    fontSize: 8,
    color: "#2c3e50",
  },
  tableCellBold: {
    fontWeight: "bold",
  },
  paddingHorizontal: 10,
  colSlNo: { width: 30, textAlign: "center" },
  colQuantity: { width: 50, textAlign: "center" },
  summarySection: {
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  summaryBox: {
    width: "45%",
    borderTopWidth: 2,
    borderTopColor: "#34495e",
    borderTopStyle: "solid",
    paddingTop: 10,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 5,
    paddingHorizontal: 12,
  },
  summaryLabel: {
    fontSize: 9,
    color: "#7f8c8d",
  },
  summaryValue: {
    fontSize: 9,
    color: "#2c3e50",
    fontWeight: "bold",
  },
  summaryTotal: {
    backgroundColor: "#2c3e50",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginTop: 5,
    borderRadius: 3,
  },
  summaryTotalLabel: {
    fontSize: 11,
    color: "#ecf0f1",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  summaryTotalValue: {
    fontSize: 12,
    color: "#3498db",
    fontWeight: "bold",
  },
  summaryDivider: {
    height: 1,
    backgroundColor: "#ccc",
    marginVertical: 6,
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 10,
    borderTopWidth: 2,
    borderTopColor: "#34495e",
    borderTopStyle: "solid",
  },
  footerLeft: {
    flex: 1,
  },
  footerText: {
    fontSize: 8,
    color: "#7f8c8d",
    marginBottom: 2,
  },
  footerBold: {
    fontSize: 9,
    color: "#2c3e50",
    fontWeight: "bold",
  },
  footerRight: {
    alignItems: "flex-end",
  },
  footerThankYou: {
    fontSize: 9,
    color: "#3498db",
    fontWeight: "bold",
    fontStyle: "italic",
  },
});

const formatDate = (raw) => {
  if (!raw) return "-";
  // support epoch seconds or ms or ISO string
  const n = Number(raw);
  let d;
  if (!Number.isNaN(n)) {
    // if value looks like seconds (10 digits) convert to ms
    d = n < 1e12 ? new Date(n * 1000) : new Date(n);
  } else {
    d = new Date(raw);
  }
  if (isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-IN");
};

const safeNum = (v) => (Number(v) ? Number(v) : 0);

const InvoicePDF = ({ data }) => {
  // expect the structure you posted:
  // data.restaurantInvoicesDetails and data.hotelDetails
  if (!data || !data.restaurantInvoicesDetails || !data.hotelDetails) {
    return (
      <Document>
        <Page>
          <Text>No data available</Text>
        </Page>
      </Document>
    );
  }

  const inv = data.restaurantInvoicesDetails;
  const hotel = data.hotelDetails || {};
  const gstEnabled = data.gstEnabled || false;
  const items = Array.isArray(inv.items) ? inv.items : [];

  // compute sums in case values are missing or inconsistent in source
  const computedSubtotal = items.reduce((s, it) => s + safeNum(it.amount), 0);
  // If the payload already has amount, prefer that but keep computed as fallback
  const subtotal = safeNum(inv.amount) || computedSubtotal;
  const sgst = safeNum(inv.sgst);
  const cgst = safeNum(inv.cgst);
  const totalFromPayload = safeNum(inv.total);
  // Compute grand total if not present
  const computedTotal = subtotal + sgst + cgst;
  const grandTotal = totalFromPayload || computedTotal;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header} fixed>
          <View style={styles.headerLeft}>
            {hotel.logo ? (
              <View style={styles.logoContainer}>
                <Image src={hotel.logo} style={styles.logo} />
              </View>
            ) : (
              <View style={styles.logoContainer}>
                <Text style={{ fontSize: 8, padding: 6, color: "#7f8c8d" }}>
                  No Logo
                </Text>
              </View>
            )}

            <View style={styles.hotelInfo}>
              <Text style={styles.hotelName}>{hotel.name || "Restaurant"}</Text>
              {hotel.address && (
                <Text style={styles.hotelContact}>{hotel.address}</Text>
              )}
              {(hotel.mobile || hotel.phone) && (
                <Text style={styles.hotelContact}>
                  Ph: {hotel.mobile || hotel.phone}
                </Text>
              )}
              {hotel.email && (
                <Text style={styles.hotelContact}>Email: {hotel.email}</Text>
              )}
              {hotel.gstin && (
                <Text style={styles.hotelContact}>GSTIN: {hotel.gstin}</Text>
              )}
            </View>
          </View>

          <View style={styles.headerRight}>
            <Text style={styles.invoiceTitle}>TAX INVOICE</Text>

            <View style={styles.invoiceBox}>
              <Text style={styles.invoiceLabel}>Invoice No.</Text>
              <Text style={styles.invoiceValue}>{inv.inv_no}</Text>
            </View>

            <View
              style={[
                styles.invoiceBox,
                { marginTop: 5, backgroundColor: "#34495e" },
              ]}
            >
              <Text style={styles.invoiceLabel}>Date</Text>
              <Text style={styles.invoiceValue}>
                {formatDate(inv.inv_date)}
              </Text>
            </View>
          </View>
        </View>

        {/* Customer & Invoice Info */}
        <View style={styles.infoGrid}>
          <View style={styles.infoRow}>
            <View style={styles.infoBox}>
              <Text style={styles.infoTitle}>Customer</Text>
              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Name:</Text>
                <Text style={styles.infoValue}>
                  {inv.customer_name || "Walk-in Customer"}
                </Text>
              </View>

              {inv.customer_mobile ? (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Mobile:</Text>
                  <Text style={styles.infoValue}>{inv.customer_mobile}</Text>
                </View>
              ) : null}

              {inv.remarks ? (
                <View style={styles.infoDetailRow}>
                  <Text style={styles.infoLabel}>Remarks:</Text>
                  <Text style={styles.infoValue}>{inv.remarks}</Text>
                </View>
              ) : null}
            </View>

            <View style={[styles.infoBox, { borderLeftColor: "#e74c3c" }]}>
              <Text style={styles.infoTitle}>Payment</Text>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Status:</Text>
                <Text style={styles.infoValue}>
                  {inv.pmt_status ? inv.pmt_status.toUpperCase() : "UNPAID"}
                </Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Subtotal:</Text>
                <Text style={styles.infoValue}>
                  {Number(subtotal).toFixed(2)}
                </Text>
              </View>

              <View style={styles.infoDetailRow}>
                <Text style={styles.infoLabel}>Total:</Text>
                <Text style={styles.infoValue}>
                  {Number(grandTotal).toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Items Table */}
        <View style={styles.table}>
          <View style={styles.tableHeader} fixed>
            <Text style={[styles.tableHeaderText, styles.colDate]}>Sl.No</Text>
            <Text style={[styles.tableHeaderText, styles.colDesc]}>
              Description
            </Text>
            <Text style={[styles.tableHeaderText, styles.colDate]}>Qty</Text>
            <Text style={[styles.tableHeaderText, styles.colRoom]}>Rate</Text>
            <Text style={[styles.tableHeaderText, styles.colAmount]}>
              Amount
            </Text>
          </View>

          {items.map((it, idx) => (
            <View
              key={idx}
              style={[
                styles.tableRow,
                idx % 2 === 1 ? styles.tableRowAlt : null,
              ]}
            >
              <Text style={[styles.tableCell, styles.colSlNo]}>{idx + 1}</Text>
              <Text style={[styles.tableCell, styles.colDesc]}>
                {it.item_name || it.particulars || "-"}
              </Text>
              <Text style={[styles.tableCell, styles.colQuantity]}>
                {safeNum(it.quantity)}
              </Text>
              <Text style={[styles.tableCell, styles.colRoom]}>
                {Number(it.rate).toFixed(2)}
              </Text>
              <Text
                style={[
                  styles.tableCell,
                  styles.colAmount,
                  styles.tableCellBold,
                ]}
              >
                {Number(
                  it.amount || safeNum(it.quantity) * safeNum(it.rate)
                ).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>

        {/* Summary */}
        <View style={styles.summarySection} wrap={false}>
          <View style={styles.summaryBox}>
            <View style={styles.summaryRow}>
              <Text style={styles.summaryLabel}>Subtotal</Text>
              <Text style={styles.summaryValue}>
                {Number(subtotal).toFixed(2)}
              </Text>
            </View>

            {gstEnabled && (
              <>
                <View style={styles.summaryRow}>
                  <Text style={styles.infoLabel}>SGST:</Text>
                  <Text style={styles.summaryValue}>
                    {Number(sgst).toFixed(2)}
                  </Text>
                </View>

                <View style={styles.summaryRow}>
                  <Text style={styles.infoLabel}>CGST:</Text>
                  <Text style={styles.summaryValue}>
                    {Number(cgst).toFixed(2)}
                  </Text>
                </View>
              </>
            )}

            <View style={styles.summaryDivider} />

            <View style={styles.summaryTotal}>
              <Text style={styles.summaryTotalLabel}>Grand Total</Text>
              <Text style={styles.summaryTotalValue}>
                {Number(grandTotal).toFixed(2)}
              </Text>
            </View>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <View style={styles.footerLeft}>
            <Text style={styles.footerText}>
              Generated on: {new Date().toLocaleDateString("en-IN")}
            </Text>
            <Text style={styles.footerBold}>
              For any queries, contact:{" "}
              {hotel.mobile || hotel.phone || hotel.email || "-"}
            </Text>
          </View>

          <View style={styles.footerRight}>
            <Text style={styles.footerThankYou}>
              Thank you for dining with us!
            </Text>
            <Text style={[styles.footerText, { marginTop: 3 }]}>
              {hotel.name}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default InvoicePDF;
